import React from 'react';

import { Link } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  button: {
    alignSelf: 'flex-start',
    fontSize: 13,
    fontWeight: 600,
  },
}));

interface ShowMoreButtonProps {
  expanded: boolean;
  onToggle: () => void;
  /** How many items the collapsed state hides; omitted for text clamps. */
  hiddenCount?: number;
}

/** The "Show more / Show less" toggle under a clamped popover section. */
export const ShowMoreButton = React.memo(function ShowMoreButton({
  expanded,
  hiddenCount,
  onToggle,
}: ShowMoreButtonProps): JSX.Element {
  const { classes } = useStyles();
  const label = expanded
    ? 'Show less'
    : hiddenCount === undefined
      ? 'Show more'
      : `Show ${hiddenCount} more`;

  return (
    <Link
      aria-expanded={expanded}
      className={classes.button}
      component="button"
      type="button"
      underline="hover"
      onClick={onToggle}
    >
      {label}
    </Link>
  );
});
